import React from "react";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import CheckoutAccordion from "repoV2/features/CheckoutPages/modules/CheckoutAccordion/CheckoutAccordion";
import CheckoutFormGroupHeader from "repoV2/features/CheckoutPages/modules/CheckoutFormGroupHeader/CheckoutFormGroupHeader";
import checkoutAccordianStyles from "repoV2/features/CheckoutPages/modules/CheckoutAccordion/CheckoutAccordion.module.scss";
import MerchandiseTitleSection from "./modules/MerchandiseTitleSection/MerchandiseTitleSection";
import useMerchandiseDetailsFormGroup from "./utils/MerchandiseDetailsFormGroup.utils";
import VariantSelectorSection from "./modules/VariantSelectorSection/VariantSelectorSection";
import styles from "./MerchandiseDetailsFormGroup.module.scss";
import MerchandiseQuantitySelector from "./modules/MerchandiseQuantitySelector/MerchandiseQuantitySelector";
import EstimatedDeliveryComponent from "./modules/EstimatedDeliveryComponent/EstimatedDeliveryComponent";

const MerchandiseDetailsFormGroup = () => {
    const {
        order,
        renderData,
        selectedVariants,
        handleSelectedVariantChange,
        variantImages,
        variantQuantity,
        isVariantSelected,
        selectedMerchandiseVariant,
        shippingDate,
        shippingDays,
        isShiprocketEnabled,
        isVariantMerchandise,
        outOfStockVariants,
    } = useMerchandiseDetailsFormGroup();

    return (
        <CheckoutAccordion
            defaultExpanded
            showExpandIcon={false}
            title={
                <CheckoutFormGroupHeader
                    title="Item Details"
                    iconJSX={
                        <BookmarkIcon className={styles.headerIconStyle} />
                    }
                />
            }
            className={checkoutAccordianStyles.Wrapper}
            disabled
            classes={{
                root: checkoutAccordianStyles.formGroupRoot,
                disabled: checkoutAccordianStyles.formGroupDisabled,
            }}
            headerClasses={{
                root: checkoutAccordianStyles.headerRoot,
                content: checkoutAccordianStyles.headerContent,
                disabled: checkoutAccordianStyles.formGroupDisabled,
                expanded: checkoutAccordianStyles.formGroupExpanded,
            }}
        >
            <MerchandiseTitleSection varinatImages={variantImages} />
            <MerchandiseQuantitySelector
                totalQuantity={variantQuantity}
                isVariantSelected={isVariantSelected}
                isVariantMerchandise={isVariantMerchandise}
            />
            <VariantSelectorSection
                order={order}
                renderData={renderData}
                selectedVariants={selectedVariants}
                isVariantSelected={isVariantSelected}
                selectedMerchandiseVariant={selectedMerchandiseVariant}
                outOfStockVariants={outOfStockVariants}
                handleSelectedVariantChange={handleSelectedVariantChange}
            />
            {!isShiprocketEnabled && shippingDays ? (
                <div className={styles.shiprocketContainer}>
                    <EstimatedDeliveryComponent shippingDate={shippingDate} />
                </div>
            ) : (
                <></>
            )}
        </CheckoutAccordion>
    );
};

export default MerchandiseDetailsFormGroup;
